import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar';
import PageTitle from '../../components/pagetitle';
import Attorney from '../../components/attorneys';
import Footer from '../../components/footer';
import Scrollbar from '../../components/scrollbar';
import Logo from '../../images/logo.svg';

import SEO from '../../SEO';
import { getRouteMeta } from '../../seo/routes';

const AttorneysPage = () => {
  return (
    <Fragment>
      <SEO {...getRouteMeta('/equipo')} />
      <Navbar
        hclass={'wpo-header-style-2'}
        Logo={Logo}
        topbarNone={'header-without-topbar'}
      />
      <PageTitle pageTitle={'Nuestro Equipo'} pagesub={'Equipo'} />
      <Attorney />
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};
export default AttorneysPage;
